<template>
  <div>
    <!-- TODO: Move core components outside -->
    <content-header title="Member Details" :sub-title="subTitle" class="mb-0 mt--10"/>
    <el-form :ref="'form-' + memberId" :model="member" :rules="rules" label-position="top">
      <el-row :gutter="60">
        <el-col :span="24" :md="24" :sm="24" :xs="24">
          <upload-item :prop="member" @imgChange="handleImageChange" :isProfilePhotoRequired="get(event, 'meta.isProfilePhotoRequired')" :photoRequiredNote="get(event, 'meta.photoRequiredNote')" :type="'members'" :label="'Members'"/>
        </el-col>
      </el-row>
      <h3>Personal Details</h3>
      <el-row :gutter="60">
        <el-col :span="24" :md="8" class="mt-10">
          <el-input-title required>{{memberIdLabel}}</el-input-title>
          <el-form-item prop="_id">
            <el-input class="mt-05 readonly-disabled" v-model="member._id" readonly autocomplete="off"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="60">
        <el-col :span="24" :md="8" class="mt-10">
          <el-input-title required>First Name</el-input-title>
          <el-form-item prop="profile.firstName">
            <el-input class="mt-05 readonly-disabled" v-model="member.profile.firstName" placeholder="Type here..." readonly autocomplete="off"/>
          </el-form-item>
        </el-col>
        <el-col :span="24" :md="8" class="mt-10">
          <el-input-title required>Last Name</el-input-title>
          <el-form-item prop="profile.lastName">
            <el-input class="mt-05 readonly-disabled" v-model="member.profile.lastName" placeholder="Type here..." readonly autocomplete="off"/>
          </el-form-item>
        </el-col>
        <el-col :span="24" :md="8" class="mt-10" v-if="national !== 10">
          <el-input-title>Preferred Name</el-input-title>
          <el-form-item prop="profile.preferredName">
            <el-input class="mt-05" v-model="member.profile.preferredName" placeholder="Type here..."/>
          </el-form-item>
        </el-col>
        <el-col :span="24" :md="8" class="mt-10">
          <el-input-title required>Gender</el-input-title>
          <el-form-item prop="profile.gender">
            <el-select class="mt-05 w-100" v-model="member.profile.gender" placeholder="Select" disabled autocomplete="off">
              <el-option
                v-for="item in genders"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24" :md="8" class="mt-10" v-if="national === 10">
          <el-input-title required>Preferred First Name</el-input-title>
          <el-form-item prop="profile.preferredFirstName">
            <el-input
              class="mt-05"
              v-model="member.profile.preferredFirstName"
              placeholder="Type here..."
            />
          </el-form-item>
        </el-col>
        <el-col :span="24" :md="8" class="mt-10">
          <el-input-title required>Date of Birth</el-input-title>
          <el-form-item prop="profile.dob">
            <el-input class="mt-05 readonly-disabled" :value="member.profile.dob | formatDob" placeholder="Type here..." readonly autocomplete="off"/>
          </el-form-item>
        </el-col>
        <el-col :span="24" :md="8" class="mt-10">
          <el-input-title required>Country</el-input-title>
          <el-form-item prop="profile.nationality">
            <!-- <el-autocomplete
              class="mt-05 w-100"
              v-model="member.profile.nationality"
              :fetch-suggestions="searchCountry"
              placeholder="Select"
            ></el-autocomplete> -->
            <el-select
              filterable
              remote
              reserve-keyword
              class="mt-05 w-100"
              v-model="member.profile.nationality"
              @blur="checkNationality(`form-${memberId}`)"
              :remote-method="searchCountry"
              placeholder="Select">
              <el-option
                v-for="item in countryItems"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-divider />
      <el-row type="flex" align="middle" :gutter="10">
        <el-col :span="16">
          <h3>Contact Details</h3>
        </el-col>
        <el-col :span="14" class="d-flex flex-justify-end justify-content-end" v-if="!member.isMainProfile">
          <el-checkbox v-model="hasPrimaryDetails">Use Primary Member Details</el-checkbox>
        </el-col>
      </el-row>
      <el-row :gutter="60">
        <el-col :span="24" :md="12" class="mt-10">
          <el-input-title required>Email Address</el-input-title>
          <el-form-item prop="profile.email">
            <el-input class="mt-05" v-model="member.profile.email" placeholder="Type here..." />
          </el-form-item>
        </el-col>
        <el-col :span="24" :md="12" class="mt-10">
          <el-input-title required>Mobile</el-input-title>
          <el-form-item prop="profile.mobile">
            <vue-tel-input
             autoFormat
             autoDefaultCountry
             :defaultCountry="countryCode"
             dropdownOptions.showDialCodeInSelection="false"
             @open="openFlagDropdown = true"
            @close="openFlagDropdown = false"
            @country-changed="handleCountryChanged"
             v-model="member.profile.mobile">
              <template v-slot:arrow-icon>
                <span><i v-if="openFlagDropdown" class="el-icon-arrow-up"></i> <i class="el-icon-arrow-down"></i></span>
              </template>
            </vue-tel-input>
          </el-form-item>
        </el-col>
        <el-col :span="24" class="mt-10 d-flex flex-column-reverse">
          <el-form-item prop="profile.address.formatted">
            <el-input v-if="member.profile.address.isManual" class="mt-05" v-model="member.profile.address.formatted"/>
            <google-auto-complete
              v-else
              class="auto-complete mt-05"
              :id="'map-' + memberId"
              :key="memberId"
              :ref="'address-' + memberId"
              @change="checkAddress($event, '-' + memberId)"
              @blur="validateAddress('-' + memberId)"
              @placechanged="getAddressData"
              v-model="member.profile.address.formatted"
              placeholder="Enter an Address">
            </google-auto-complete>
          </el-form-item>
          <div class="d-flex justify-content-between">
            <div>Address<span class="c-red ml-02">*</span></div>
            <el-button class="py-0 fs-09 op-7 manualAddressBtn" type="text" @click="manualAddress">
              {{ member.profile.address.isManual ? 'Search Address' : 'Enter Address Manually' }}
            </el-button>
          </div>
        </el-col>
        <el-col :span="24" :md="12" class="mt-10" v-if="member.profile.address.isManual">
          <el-input-title required>Address Line 1</el-input-title>
          <el-form-item prop="profile.address.addressLine1">
            <el-input class="mt-05" v-model="member.profile.address.addressLine1" placeholder="Type here..." />
          </el-form-item>
        </el-col>
        <el-col :span="24" :md="12" class="mt-10" v-if="member.profile.address.isManual">
          <el-input-title>Address Line 2</el-input-title>
          <el-form-item prop="profile.address.addressLine2">
            <el-input class="mt-05" v-model="member.profile.address.addressLine2" placeholder="Type here..." />
          </el-form-item>
        </el-col>
        <el-col :span="24" :md="12" class="mt-10" v-if="member.profile.address.isManual">
          <el-input-title required>City/Suburb</el-input-title>
          <el-form-item prop="profile.address.suburb">
            <el-input class="mt-05" v-model="member.profile.address.suburb" placeholder="Type here..." />
          </el-form-item>
        </el-col>
        <el-col :span="24" :md="12" class="mt-10" v-if="member.profile.address.isManual">
          <el-input-title :required="nationalId !== 17">State</el-input-title>
          <el-form-item prop="profile.address.state">
            <el-input class="mt-05" v-model="member.profile.address.state" placeholder="Type here..." />
          </el-form-item>
        </el-col>
        <el-col :span="24" :md="12" class="mt-10" v-if="member.profile.address.isManual">
          <el-input-title required>Postcode</el-input-title>
          <el-form-item prop="profile.address.postcode">
            <el-input class="mt-05" v-model="member.profile.address.postcode" placeholder="Type here..." />
          </el-form-item>
        </el-col>
        <el-col :span="24" :md="12" class="mt-10" v-if="member.profile.address.isManual">
          <el-input-title required>Country</el-input-title>
          <el-form-item prop="profile.address.country">
            <el-select
              filterable
              remote
              reserve-keyword
              class="mt-05 w-100"
              v-model="member.profile.address.country"
              :remote-method="searchCountry"
              placeholder="Select">
              <el-option
                v-for="item in countryItems"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-divider />
        <h3>Emergency Contact</h3>
        <el-row :gutter="60">
          <el-col :span="24" :md="12">
            <el-input-title required>Name</el-input-title>
            <el-form-item prop="profile.emergency.name">
              <el-input class="mt-05"
                v-model="member.profile.emergency.name"
                placeholder=""
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24" :md="12">
            <el-input-title required>Mobile</el-input-title>
            <el-form-item prop="profile.emergency.mobile">
              <vue-tel-input
             autoFormat
             autoDefaultCountry
             :defaultCountry="countryCode"
             dropdownOptions.showDialCodeInSelection="false"
             @open="openFlagDropdown = true"
            @close="openFlagDropdown = false"
            @country-changed="handleCountryChanged"
             v-model="member.profile.emergency.mobile">
              <template v-slot:arrow-icon>
                <span><i v-if="openFlagDropdown" class="el-icon-arrow-up"></i> <i class="el-icon-arrow-down"></i></span>
              </template>
            </vue-tel-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider />
        <h3>Parent or Guardian Contact</h3>
        <el-row :gutter="60">
          <el-col :span="24" :md="8">
            <el-input-title :required="this.isUnder18">Name</el-input-title>
            <el-form-item prop="profile.meta.parentOrGuardian1.name">
              <el-input class="mt-05"
                v-model="member.profile.meta.parentOrGuardian1.name"
                placeholder=""
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24" :md="8">
            <el-input-title :required="this.isUnder18">Email</el-input-title>
            <el-form-item prop="profile.meta.parentOrGuardian1.email">
              <el-input class="mt-05"
                v-model="member.profile.meta.parentOrGuardian1.email"
                placeholder=""
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24" :md="8">
            <el-input-title :required="this.isUnder18">Mobile</el-input-title>
            <el-form-item prop="profile.meta.parentOrGuardian1.mobile">
              <vue-tel-input
             autoFormat
             autoDefaultCountry
             :defaultCountry="countryCode"
             dropdownOptions.showDialCodeInSelection="false"
             @open="openFlagDropdown = true"
            @close="openFlagDropdown = false"
            @country-changed="handleCountryChanged"
             v-model="member.profile.meta.parentOrGuardian1.mobile">
              <template v-slot:arrow-icon>
                <span><i v-if="openFlagDropdown" class="el-icon-arrow-up"></i> <i class="el-icon-arrow-down"></i></span>
              </template>
            </vue-tel-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="24" :md="8">
            <el-input-title :required="this.isUnder18">Phone</el-input-title>
            <el-form-item prop="profile.meta.parentOrGuardian1.phone">
              <el-input
                class="mt-05"
                v-model="member.profile.meta.parentOrGuardian1.phone"
                placeholder="Type here..."
              ></el-input>
            </el-form-item>
          </el-col> -->
        </el-row>
        <el-divider v-if="!isPlayingType" />
        <h3 v-if="!isPlayingType">WWC Information</h3>
        <el-row  v-if="!isPlayingType" :gutter="60">
          <el-col :span="24" :md="8">
            <el-input-title>Number</el-input-title>
            <el-form-item prop="profile.meta.wwc.number">
              <el-input class="mt-05"
                v-model="member.profile.meta.wwc.number"
                placeholder=""
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24" :md="8">
            <el-input-title>Expiry</el-input-title>
            <el-form-item prop="profile.meta.wwc.expiry" >
              <el-date-picker class="mt-05"
                v-model="member.profile.meta.wwc.expiry"
                placeholder=""
                value-format="timestamp"
                :clearable="false"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="24" :md="8">
            <el-input-title>Issuer</el-input-title>
            <el-form-item prop="profile.meta.wwc.issuer" >
              <el-select class="mt-05"
                filterable
                v-model="member.profile.meta.wwc.issuer"
                placeholder=""
              >
                <el-option
                  v-for="{ label, value } in states"
                  :key="value"
                  :label="label"
                  :value="value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <component :is="customMemberDetailForm" v-model="member" :key="key" :refs="$refs.form"/>
        <el-form-item v-if="isTCRequired">
          <el-checkbox v-model="isTCAccepted" size="medium" class="mt-10">I agree to the <a href="javascript: void(0);" @click="dialogVisible = true">Terms and Conditions</a></el-checkbox>
        </el-form-item>
        <section class="media-consent-section" v-if="national === 6">
          <textarea disabled class="media-consent">Fencing Victoria wishes to record photographic and/or video images of you/your child for the purposes of:

Use in digital or physical material for promoting the sport of fencing in Victoria; or
Broadcasting competitions and other events.
Fencing Victoria, nor any of its agents, volunteers, or employees, will not:

Use the photographs/videos for any other purpose than those stated above;
Use them in any manner in breach of the law or the Safe Sport Framework;
Record any personal or identifying information about the persons in the photographs/videos together with such photographs/videos;
Publish or distribute any part or all of the photographs/videos without your consent; and
Compromise the confidentiality of any personal or identifying information collected.
If you have any concerns about the taking or use of photographs/videos, please contact president@fencingvictoria.org

Fencing Victoria is required to maintain security cameras for safety and security purposes in the State Fencing Centre. These record 24 hours per day, 7 days a week. Anyone using the Centre at any time is subject to being recorded for these purposes. No recording obtained through the security cameras will be used for any other purpose than for safety and security.

Fencing Victoria photographs and posts photos of the podium of medal-winning fencers from each competition. Should you or your child not agree to have your photographs used in line with the above policy, it is the responsibility of the individual or parent/guardian to ensure you/your child is not on the podium at the time photos are taken.
  </textarea>
          <el-form-item>
            <div class="consent-options">
              <el-radio-group v-model="mediaConsentChoice">
                <el-radio :label="'consent'" class="consent-option">
                  I give Fencing Victoria permission to use photographs/videos taken of me/my child solely for the purposes stated above and subject to the conditions set out in this form.
                </el-radio>
                <el-radio :label="'decline'" class="consent-option">
                  I do not give Fencing Victoria permission to use photographs/videos taken of me/my child.
                </el-radio>
              </el-radio-group>
            </div>
          </el-form-item>
        </section>
    </el-form>
    <el-dialog
      v-if="isTCRequired"
      :visible.sync="dialogVisible"
      :fullscreen="true"
      >
      <div style="width:100%;height:100%">
        <pdf
          v-for="i in numPages"
          :key="i"
          :src="src"
          :page="i"
        ></pdf>

      </div>
      </el-dialog>

  </div>
</template>

<script>
import _ from 'lodash';
import { calculateMemberAge, checkValidMobile } from '@/utils/helpers';
import playerDetails from '@/mixins/player-details';
import { VueTelInput } from 'vue-tel-input';
import { clientNationalIds } from '@/utils/client-rules';
import pdf from 'vue-pdf';
import { countries } from '@/utils/constants';
import moment from 'moment';
// import parsePhoneNumberFromString from 'libphonenumber-js';
import UploadItem from '../components/UploadItem';

const parstAddressFormatted = (address) => {
  const {
    addressLine1,
    addressLine2,
    suburb,
    state,
    postcode,
    country
  } = address;
  return `${addressLine1}${addressLine2 ? ` ${addressLine2}` : ''}, ${suburb} ${state}, ${postcode}, ${country}`;
};

export default {
  name: 'PlayerDetails',
  mixins: [playerDetails],
  props: {
    memberId: Number,
    event: Object,
    editing: Boolean,
    editingRego: Object,
  },
  components: {
    pdf,
    VueTelInput,
    UploadItem
  },
  data() {
    // const validateMobile = (rule, value, callback) => {
    //   if (!value) {
    //     return callback(new Error('Mobile is required'));
    //   }
    //   // join value remomve all space
    //   // eslint-disable-next-line no-param-reassign
    //   value = value.replace(/\s/g, '');
    //   const phoneNumber = parsePhoneNumberFromString(value, this.countryCode);
    //   const test = !!(((phoneNumber && phoneNumber.isValid() && (phoneNumber.getType() === 'MOBILE' || phoneNumber.getType() === 'FIXED_LINE_OR_MOBILE'))));
    //   if (test) return callback();
    //   return callback(new Error('Invalid mobile'));
    // };
    return {
      countryDialCode: this.getCountryDialCode(),
      countryCode: this.getCountryCode(),
      nationalId: +process.env.VUE_APP_NATIONAL_ID,
      subTitle: 'Edit your member\'s contact information. This will be forwarded to the entity you are registering to',
      nationalMemberTypes: [],
      key: 0,
      isTCAccepted: false,
      isTCRequired: false,
      dialogVisible: false,
      src: undefined,
      numPages: undefined,
      showTandC: false,
      countryItems: countries,
      countries,
      openFlagDropdown: false,
      get: _.get,
      hasProfilePic: false,
      hasPrimaryDetails: false,
      rules: {
        'profile.firstName': { required: true, trigger: 'blur', message: 'First Name is required' },
        'profile.lastName': { required: true, trigger: 'blur', message: 'Last Name is required' },
        'profile.email': {
          required: true,
          type: 'email',
          trigger: ['blur', 'change'],
          message: 'Valid Email is required'
        },
        'profile.mobile': {
          required: true,
          validator: (rule, value, callback) => checkValidMobile(rule, value, callback, this.isUnder18, this.countryCode),
          trigger: ['blur', 'change'],
        },
        'profile.address.addressLine1': {
          required: true,
          trigger: ['blur', 'change'],
          message: 'Address Line 1 is required'
        },
        'profile.address.suburb': {
          required: true,
          trigger: 'blur',
          message: 'Suburb is required'
        },
        'profile.address.state': {
          required: true,
          trigger: 'blur',
          message: 'State is required'
        },
        'profile.address.postcode': {
          required: true,
          trigger: 'blur',
          message: 'Postcode is required'
        },
        'profile.address.country': {
          required: true,
          trigger: 'blur',
          message: 'Country is required'
        },
        'profile.emergency.contactName': {
          required: true,
          trigger: 'blur',
          message: 'Emergency Contact Name is required'
        },
        'profile.emergency.mobile': {
          required: true,
          trigger: 'blur',
          validator: (rule, value, callback) => checkValidMobile(rule, value, callback, this.isUnder18, this.countryCode),
          message: 'Emergency Contact Number is required'
        },
        'profile.nationality': {
          required: true,
          trigger: 'blur',
          message: 'Nationality is required'
        }
      },
      mediaConsentChoice: null,
    };
  },
  async mounted() {
    window.scrollTo(0, 0);

    this.$store.commit('loading', { loading: true, text: 'Loading...' });

    // Check if T&C is required from the event
    if (this.event) {
      this.isTCRequired = this.event?.products[0]?.isTCRequired || this.event?.isTCRequired || false;
    } else if (this.editingRego) {
      this.isTCRequired = this.editingRego?.product?.isTCRequired || this.editingRego?.isTCRequired || false;
    }
    if (!this.isTCRequired) {
      this.$emit('tc-update', false);
    }
    const productTcRequired = this.event?.products[0]?.isTCRequired || this.editingRego?.product?.isTCRequired || false;
    const eventTcRequired = this.event?.isTCRequired || this.editingRego?.isTCRequired || false;
    // If T&C required at the event level
    if (productTcRequired) {
      // If T&C required at the product level
      try {
        const eventId = this.event?._id || this.editingRego?.entityId;
        const productId = this.event?.products[0]?._id || this.editingRego?.product._id;
        const resEvent = await this.$http.get(`/assemble/api/v1/portal/files/entity/${eventId}/product/${productId}/signed`);
        if (resEvent && resEvent.data) {
          const url = resEvent.data.url.toString();
          try {
            this.src = pdf.createLoadingTask(url);
            const data = await pdf.createLoadingTask(url).promise;
            this.numPages = data._pdfInfo.numPages;
            const isTcPrefilled = this.event?.products[0]?.isTCPrefilled || this.editingRego?.product?.isTCPrefilled || false;
            this.isTCAccepted = isTcPrefilled;
          } catch (error) {
            this.isTCRequired = false;
            this.$emit('tc-update', false);
          }
        }
      } catch (error) {
        this.isTCRequired = false;
        this.$emit('tc-update', false);
      }
    } else if (eventTcRequired) {
      // If T&C required at the event level
      try {
        const eventId = this.event?._id || this.editingRego?.entityId;
        const resEvent = await this.$http.get(`/assemble/api/v1/portal/files/entity/${eventId}/signed`);
        if (resEvent && resEvent.data) {
          const url = resEvent.data.url.toString();
          try {
            this.src = pdf.createLoadingTask(url);
            const data = await pdf.createLoadingTask(url).promise;
            this.numPages = data._pdfInfo.numPages;
            const isTcPrefilled = this.event?.isTCPrefilled || this.editingRego?.isTCPrefilled || false;
            this.isTCAccepted = isTcPrefilled;
          } catch (error) {
            this.isTCRequired = false;
            this.$emit('tc-update', false);
          }
        }
      } catch (error) {
        this.isTCRequired = false;
        this.$emit('tc-update', false);
      }
    } else {
      this.$emit('tc-update', false);
    }

    this.$store.commit('loading', false);

    if (this.memberId && this.event) {
      this.$store.commit('loading', { loading: true, text: 'Loading...' });
      Promise.all([
        this.$http.get(`/assemble/api/v1/account/portal/members/${this.memberId}`),
        this.$http.get('/assemble/api/v1/portal/nationals/member-types')
      ]).then(([res, resMT]) => {
        this.nationalMemberTypes = resMT.data.data;

        this.$set(this, 'member', _.merge({}, this[`${this.currentNational}Data`], res.data.data));

        const member = res.data.data;
        console.log('member.isMediaConsent', member.isMediaConsent);
        if (member.isMediaConsent === true) {
          this.mediaConsentChoice = 'consent';
        } else if (member.isMediaConsent === false) {
          this.mediaConsentChoice = 'decline';
        }

        if (_.get(this.member, 'meta.imgUrl', false)) {
          this.hasProfilePic = true;
        }
        this.key++;
        const { dob, gender } = this.member.profile;

        /* --- Convert event to registration --- */
        const {
          _id,
          name,
          meta,
          registrationType,
          productType,
          memberType,
          tags,
          products,
          additionalQs,
          saleableItems,
          discounts,
          acceptActiveKids,
          multipleRegoDiscounts,
          multipleSaleableItemDiscounts,
          startDate,
          endDate,
          isRenewable,
          entityType,
          entityCustomDateCutoff,
          memberIds,
          isBulk,
          requiresApproval,
          isTCRequired
        } = this.event;

        let endOfYear = this.$store.getters['national/endOfYear'];
        if (entityType !== 'national' && entityCustomDateCutoff && entityCustomDateCutoff.useCustomDateCutoff) {
          const { customDateCutoffMonth, customDateCutoffDay } = entityCustomDateCutoff;
          endOfYear = `${moment().year()}-${customDateCutoffMonth}-${customDateCutoffDay}`;
        }

        const { ageAsOfDate, ageCalculationType } = meta || {};
        // eslint-disable-next-line no-nested-ternary
        const regoEndOfYear = ageCalculationType === 'specific'
          ? moment(ageAsOfDate).format('YYYY-MM-DD')
          : ageCalculationType === 'registration'
            ? moment().format('YYYY-MM-DD')
            : ageAsOfDate || endOfYear;

        const age = calculateMemberAge(dob, regoEndOfYear);

        // Filters
        const filterAgeAndGender = (e) => age >= e.ageFrom && age <= e.ageTo && (e.gender === gender || e.gender === 'All' || !e.gender || (e.gender === 'Other' && (gender !== 'Male' || gender !== 'Female')));
        const filterAll = (e) => _.includes(e.productTypes, productType) && _.includes(e.memberTypes, memberType) && filterAgeAndGender(e);

        this.registration = {
          entityName: name,
          entityType: registrationType,
          entityLevel: entityType,
          entityId: _id,
          memberId: this.member._id,
          profile: this.member.profile,
          productType,
          memberType,
          tags,
          isRenewable: isRenewable || false,
          product: _.find(products, (p) => filterAgeAndGender(p)),
          additionalQs: _.filter(additionalQs, (q) => filterAll(q)),
          saleableItems: _.filter(saleableItems, (i) => filterAll(i)),
          discounts: _.filter(discounts, (i) => filterAgeAndGender(i) && i.productType === 'indv'
          && _.includes(i.memberTypes, memberType)
          && (i.from <= +this.moment()
          && +this.moment() <= i.to)),
          acceptActiveKids,
          multipleRegoDiscounts,
          multipleSaleableItemDiscounts,
          startDate,
          endDate,
          entityLogo: _.get(this.event, 'entityLogo', ''),
          requiresApproval,
          isTCRequired
        };
        if (isBulk) {
          this.registration.memberIds = memberIds;
          this.registration.isBulk = true;
          this.$emit('update-step', this.registration, 1);
        }
        this.$emit('update-step', this.registration, 0);

        this.$store.commit('loading', false);
      }).catch((e) => {
        console.error(e);
        this.$store.commit('loading', false);
      });
    } else if (this.editingRego && this.memberId) {
      this.$store.commit('loading', { loading: true, text: 'Loading...' });
      const resMember = await this.$http.get(`/assemble/api/v1/account/portal/members/${this.memberId}`);
      this.$set(this, 'member', _.merge({}, this[`${this.currentNational}Data`], resMember.data.data));
      this.registration = _.cloneDeep(this.editingRego);
      this.$store.commit('loading', false);
    }
  },

  methods: {
    getCountryDialCode() {
      const nationalId = +process.env.VUE_APP_NATIONAL_ID;
      switch (nationalId) {
        case 17:
          return '64'; // New Zealand
        case 21:
          return '65'; // Singapore
        default:
          return '61'; // Australia (default)
      }
    },
    getCountryCode() {
      const nationalId = +process.env.VUE_APP_NATIONAL_ID;
      switch (nationalId) {
        case 17:
          return 'NZ'; // New Zealand
        case 21:
          return 'SG'; // Singapore
        default:
          return 'AU'; // Australia (default)
      }
    },
    handleImageChange(member) {
      if (_.get(member, 'meta.imgUrl', false)) {
        this.hasProfilePic = true;
      } else {
        this.hasProfilePic = false;
      }
    },
    handleCountryChanged(countryCode) {
      this.countryDialCode = countryCode.dialCode;
      this.countryCode = countryCode.iso2.toUpperCase();
    },
    async getUrl() {
      const data = await this.$http.get('/assemble/api/v1/portal/files/7732/signed');
      const url = data.data.url.toString();
      return pdf.createLoadingTask(url);
    },
    refactorMobile(mobileNumber) {
      let mobile = _.cloneDeep(mobileNumber).replace(/\s/g, '');
      if (mobile.charAt(0) === '0') {
        mobile = mobile.substring(1);
        return `+${ this.countryDialCode }${mobile}`;
      } if (mobile.charAt(0) === '+') {
        return mobile;
      }
      if (!mobile.length) {
        return undefined;
      }
      return `+${ this.countryDialCode }${mobile}`;
    },
    updateStep() {
      this.$refs[`form-${this.memberId}`].validate((valid) => {
        if (valid) {
          // Update formatted for isManual
          if (this.member.profile.address.isManual) {
            this.member.profile.address.formatted = parstAddressFormatted(
              this.member.profile.address
            );
          }

          if (!this.member.profile.address?.addressLine1 || this.member.profile.address?.addressLine1 === 'undefined') {
            if (_.get(this, 'membership.productType') === 'family') this.$emit('validateFamilyDetail', false);
            return this.$message.error('Please enter a full address');
          }

          if (this.isUnder18) {
            if (!this.member.profile.meta.parentOrGuardian1.name) {
              return this.$message.error('Parent or Guardian Name is required');
            }
            if (!this.member.profile.meta.parentOrGuardian1.email) {
              return this.$message.error('Parent or Guardian Email is required');
            }
            if (!this.member.profile.meta.parentOrGuardian1.mobile) {
              return this.$message.error('Parent or Guardian Mobile is required');
            }
          }

          if (this.isTCRequired && !this.isTCAccepted) {
            return this.$message.error('Please accept terms and conditions');
          }

          if (this.national === 6 && this.mediaConsentChoice === null) {
            return this.$message.error('Please select a media consent option');
          }

          if (this.event && this.event.meta.isProfilePhotoRequired && !this.hasProfilePic) {
            return this.$message.error('Please upload profile photo');
          }

          if (this.member.profile.mobile) {
            this.member.profile.mobile = this.refactorMobile(this.member.profile.mobile);
          }

          if (this.member.profile.emergency.mobile) {
            this.member.profile.emergency.mobile = this.refactorMobile(this.member.profile.emergency.mobile);
          }

          if (this.member.profile.meta.parentOrGuardian1.mobile !== undefined) {
            this.member.profile.meta.parentOrGuardian1.mobile = this.refactorMobile(this.member.profile.meta.parentOrGuardian1.mobile);
          }

          this.$store.commit('loading', { loading: true, text: 'Loading...' });
          this.$http.put(`/assemble/api/v1/account/portal/members/${this.member._id}`, {
            profile: this.member.profile,
            meta: this.member.meta,
            isMediaConsent: this.isMediaConsent,
          }).then(() => {
            this.$emit('update-step', this.registration);
            this.$store.commit('loading', false);
          }).catch((e) => {
            this.$message.error(e.response.data.message);
            this.$store.commit('loading', false);
          });
        }
        return false;
      });
    },
    manualAddress() {
      this.member.profile.address.isManual = !this.member.profile.address.isManual;
      // Update formatted for isManual
      this.member.profile.address.formatted = parstAddressFormatted(
        this.member.profile.address
      );
    },
    searchCountry(query) {
      if (query !== '') {
        setTimeout(() => {
          this.countryItems = this.countries.filter((item) => item.label.toLowerCase()
            .indexOf(query.toLowerCase()) > -1);
        }, 200);
      } else {
        this.countryItems = [];
      }
    },
    removeUrlProperties(object) {
      const updatedObject = {};
      _.forEach((Object.entries(object)), ([property, value]) => {
        if (!property.toLowerCase().includes('img') && !property.toLowerCase().includes('url')) {
          updatedObject[property] = value;
        }
      });
      return updatedObject;
    },
    mapping(rData) {
      const {
        email, mobile, address, nationality, emergency, metaProfile
      } = rData.profile;
      const { meta } = rData;

      if (email) this.member.profile.email = email;
      if (mobile) this.member.profile.mobile = mobile;
      if (address) this.member.profile.address = address;
      if (emergency) this.member.profile.emergency = emergency;
      if (nationality) this.member.profile.nationality = nationality;
      if (metaProfile) this.member.profile.meta = this.removeUrlProperties(metaProfile);
      if (meta) this.member.meta = this.removeUrlProperties(meta);
    },
    clearForm(obj) {
      // eslint-disable-next-line no-restricted-syntax, guard-for-in
      for (const key in obj) {
        console.log(key);
        if (!['firstName', 'lastName', 'dob', 'gender'].includes(key)) {
          if (typeof obj[key] === 'object' && obj[key] !== null) {
            this.clearForm(obj[key]);
          } else {
            // eslint-disable-next-line no-param-reassign
            obj[key] = undefined;
          }
        }
      }
    },
  },
  computed: {
    national() {
      return +process.env.VUE_APP_NATIONAL_ID;
    },
    memberIdLabel() {
      return +process.env.VUE_APP_NATIONAL_ID === 1 ? 'NSWISA Member ID' : 'Member ID';
    },
    customMemberDetailForm() {
      const nationalId = _.includes(clientNationalIds, +process.env.VUE_APP_NATIONAL_ID) ? process.env.VUE_APP_NATIONAL_ID : 0;
      // eslint-disable-next-line
      return () => import('@/views/app/clients/' + nationalId + '-member-profile-extras.vue');
    },
    isPlayingType() {
      const eventMemberType = _.find(this.nationalMemberTypes, (m) => m.type === this.event.memberType);
      return eventMemberType && eventMemberType.playing;
    },
    userId() {
      return this.$store.getters['user/userId'];
    },
    isMediaConsent() {
      return this.mediaConsentChoice === 'consent';
    }
  },
  watch: {
    isTCAccepted(val) {
      this.$emit('tc-update', !val);
    },
    countryDialCode(val) {
      this.$emit('country-dial-code-found', val);
    },
    async hasPrimaryDetails(val) {
      if (val) {
        this.$store.commit('loading', { loading: true, text: 'Loading...' });
        const res = await this.$http.get(`/assemble/api/v1/portal/members/primary-details/${this.userId}`);
        console.log(res.data.data.member);
        this.mapping(res.data.data.member);
        this.key++;
        this.$store.commit('loading', false);
      } else {
        this.clearForm(this.member);
      }
    },
  }
};
</script>

<style scoped lang="scss">
.el-date-editor,
.el-select,
.el-input {
  width: 100%;
}
.manualAddressBtn {
  &:hover {
    color: $highlight !important;
  }
  &:focus {
    border-color: #222 !important;
  }
}

.media-consent {
  width: 100% !important;
  min-height: 10vh;
  padding: 1rem;
  line-height: 24px;
  margin-top: 1.5rem;
}

::v-deep .el-dialog {
  max-width: 900px !important;
}

.consent-options {
  margin-top: 1rem;
}

.consent-option {
  display: block;
  margin-bottom: 1rem;
  line-height: 1.5;
}
</style>
